import { defineMessages } from 'react-intl';

export default defineMessages({
    password: {
        id: 'login.password',
        defaultMessage: 'Senha'
    },
    newPassword: {
        id: 'login.newPassword',
        defaultMessage: 'Nova senha *'
    },
    confirmPassword: {
        id: 'login.confirmPassword',
        defaultMessage: 'Confirmar senha *'
    },
    wait: {
        id: 'login.wait',
        defaultMessage: 'Aguarde...'
    },
    changePassword: {
        id: 'login.changePassword',
        defaultMessage: 'Alterar Senha'
    },
    invalidPassword: {
        id: 'login.invalidPassword',
        defaultMessage: 'Senha inválida, mínimo 6 caracteres'
    },
    requiredField: {
        id: 'login.requiredField',
        defaultMessage: 'Este Campo é obrigatório'
    },
    differentPasswords: {
        id: 'login.differentPasswords',
        defaultMessage: 'As senhas são diferentes. Verifique o valor inserido'
    },
    createNewPassword: {
        id: 'login.createNewPassword',
        defaultMessage: 'Criar nova senha'
    },
    connectionProblem: {
        id: 'login.connectionProblem',
        defaultMessage: 'Não está conseguindo se conectar?'
    },
    insertEmail: {
        id: 'login.insertEmail',
        defaultMessage: 'Insira abaixo o e-mail cadastrado para recuperar sua senha.'
    },
    recoveryLinkSent: {
        id: 'login.recoveryLinkSent',
        defaultMessage: 'Link de recuperação de senha enviado com sucesso no e-mail inserido.'
    },
    linkExpiration: {
        id: 'login.linkExpiration',
        defaultMessage: 'Este link possui duração de 2 horas.'
    },
    email: {
        id: 'login.email',
        defaultMessage: 'Email'
    },
    sendRecoveryEmail: {
        id: 'login.sendRecoveryEmail',
        defaultMessage: 'Enviar e-mail de recuperação'
    },
    sendInSeconds: {
        id: 'login.sendInSeconds',
        defaultMessage: '{seconds}s Enviar'
    },
    backToHome: {
        id: 'login.backToHome',
        defaultMessage: 'Voltar para a tela inicial'
    },
    linkExpirationMessage: {
        id: 'login.linkExpirationMessage',
        defaultMessage: 'O link de recuperação de senha expirou por possuir validade de 2 horas após a solicitação.'
    },
    requestNewRecoveryLink: {
        id: 'login.requestNewRecoveryLink',
        defaultMessage: 'Por favor, solicite uma nova recuperação de senha.'
    },
    close: {
        id: 'login.close',
        defaultMessage: 'Fechar'
    },
    socialName: {
        id: 'login.socialName',
        defaultMessage: 'Nome Social'
    },
    businessName: {
        id: 'login.businessName',
        defaultMessage: 'Nome do Negócio'
    },
    fantasyName: {
        id: 'login.fantasyName',
        defaultMessage: 'Nome Fantasia'
    },
    state: {
        id: 'login.state',
        defaultMessage: 'Estado'
    },
    city: {
        id: 'login.city',
        defaultMessage: 'Cidade'
    },
    back: {
        id: 'login.back',
        defaultMessage: 'Voltar'
    },
    save: {
        id: 'login.save',
        defaultMessage: 'Salvar'
    },
    passwordsMustMatch: {
        id: 'login.passwordsMustMatch',
        defaultMessage: 'As senhas tem que ser iguais!'
    },
    name: {
        id: 'login.name',
        defaultMessage: 'Nome'
    },
    cpf: {
        id: 'login.cpf',
        defaultMessage: 'CPF'
    },
    cpfPlaceholder: {
        id: 'login.cpfPlaceholder',
        defaultMessage: '___.____.____-____'
    },
    contact: {
        id: 'login.contact',
        defaultMessage: 'Contato'
    },
    contactPlaceholder: {
        id: 'login.contactPlaceholder',
        defaultMessage: '(__) ____-____'
    },
    backToLogin: {
        id: 'login.backToLogin',
        defaultMessage: 'Voltar pro Login'
    },
    recaptchaError: {
        id: 'login.recaptchaError',
        defaultMessage: 'Não foi possível verificar seu acesso. Atualize a página ou entre em contato conosco.'
    },
    userInformation: {
        id: 'login.userInformation',
        defaultMessage: 'Informações do Usuário'
    },
    attention: {
        id: 'login.attention',
        defaultMessage: 'Atenção'
    },
    enter: {
        id: 'login.enter',
        defaultMessage: 'Entrar'
    },
    secureEnvironment: {
        id: 'login.secureEnvironment',
        defaultMessage: 'Configurando ambiente para acesso seguro...'
    },
    invalidEmail: {
        id: 'login.invalidEmail',
        defaultMessage: 'O campo email é inválido!'
    },
    recaptchaProblem: {
        id: 'login.recaptchaProblem',
        defaultMessage: 'Ocorreu algum problema. Por favor, atualize sua página e tente novamente.'
    },
    recoverPassword: {
        id: 'login.recoverPassword',
        defaultMessage: 'Recuperar senha'
    }
});
